export default {
  list: {
    create: "New contact",
  },
  update: {
    delete: "Delete contact",
  },
  create: {
    save: "Save contact",
    cancel: "Cancel",
    reset: "Reset data"
  }
}
